<template>
  <div class="more-loading-wrapper">
    <img class="" src="https://files.wondercv.com/icon/loading.gif"/>
    <span>正在加载</span>
  </div>
</template>

<script>
	export default {
		name: 'w-more-loading',
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {},
		methods: {}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  .more-loading-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90vw;
    height: 45px;
    // background: #efefef;
    border-radius: 5px;
    margin: 10px auto;
    font-size: 14px;
    color: $color-dark-gray;
    img {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
  }
</style>
